module.exports = __webpack_public_path__ + "static/media/teaser-staedtequiz.97315e0c.jpg";